<template>
    <div class="tw-header" :style="style">
        <slot></slot>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-header',
    props: {
        height: {
            type: String,
            default: null
        }
    },
    setup(props) {
        return {
            style: computed(
                () =>
                (props.height
                    ? {
                        '--tw-header-height': props.height,
                    }
                    : {})
            ),
        }
    },
}
</script>

<style>

</style>